import { Box, ConditionWrapper, Flex, Form, Text, TextField } from '@approvalmax/ui/src/components';
import { constants } from 'modules/common';
import { SectionContainer } from 'pages/requestForm/components/SectionContainer';
import { FC, memo } from 'react';
import bemFactory from 'react-bem-factory';
import { useForm } from 'react-hook-form';
import { useUserBetaFeatures } from 'shared/hooks';

import { messages } from './MemoSection.messages';
import { MemoSectionProps } from './MemoSection.types';

const qa = bemFactory.qa('memo-section');

const { commonConstants } = constants;

export const MemoSection: FC<MemoSectionProps> = memo((props) => {
    const { width, noPadding, disabled, invalid, defaultValue, placeholder, onChange, maxLength } = props;

    const { isBelgradeUIMemoMessageSection } = useUserBetaFeatures();

    const form = useForm({
        defaultValues: {
            memo: defaultValue || '',
        },
    });

    return (
        <Box width='100%'>
            <Form form={form}>
                <ConditionWrapper
                    condition={isBelgradeUIMemoMessageSection}
                    wrapperIf={(children) => (
                        <Flex direction='column'>
                            <Text font='headline' fontSize='xxsmall' fontWeight='medium' uppercase>
                                {messages.title}
                            </Text>

                            {children}
                        </Flex>
                    )}
                    wrapperElse={(children) => (
                        <SectionContainer noPadding={noPadding} qa={qa()} title={messages.title}>
                            {children}
                        </SectionContainer>
                    )}
                >
                    <TextField
                        width={width}
                        qa={qa('memo-editor')}
                        name='memo'
                        multiline
                        autoHeight
                        maxLength={maxLength || commonConstants.defaultMemoMaxLength}
                        placeholder={placeholder || messages.placeholder}
                        minHeight={124}
                        maxHeight={252}
                        onChange={onChange}
                        disabled={disabled}
                        invalid={invalid}
                    />
                </ConditionWrapper>
            </Form>
        </Box>
    );
});

MemoSection.displayName = 'MemoSection';
